import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { getAllClinicRadiologyServicesMaster } from "../../../../store/slices/clinicRadiologyService";
import { getClinicRadiologyServicesDetailsMaster } from "../../../../store/slices/clinicRadiologyServiceDetails";
import { resetgetRadiologyServicesDetails } from "../../../../store/slices/clinicRadiologyServiceDetails";
import { getAllPhysician } from "../../../../store/slices/physicianSlice";

const Radiology = ({ handleChange, isClient }) => {
  const [radiologyServicesId, setRadiologyServicesId] = useState(null);
  const [selectedRadiologyDetails, setSelectedRadiologyDetails] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);

  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { physician } = useSelector((state) => state.physician);
  const { radiologyServices } = useSelector(
    (state) => state.clinicRadiologyService
  );
  const { radiologyServicesDetails } = useSelector(
    (state) => state.clinicRadiologyServiceDetails
  );
const clinicId =clinicInfo?.[0]?.clinicId ||null;
  useEffect(() => {
    dispatch(
      getAllClinicRadiologyServicesMaster({
        clinicId,
        token,
      })
    );

    dispatch(
      getAllPhysician({
        clinicId,
        clinicStatus: "Accepted",
        physicianStatus: "Accepted",
        token,
      })
    );
  }, [dispatch, clinicId, token]);


  useEffect(() => {
    if (!radiologyServicesId) return;

    dispatch(resetgetRadiologyServicesDetails());

    dispatch(
      getClinicRadiologyServicesDetailsMaster({
        clinicId,
        serviceId: radiologyServicesId,
        token,
      })
    );

    setSelectedRadiologyDetails([]);
    handleChange([], "serviceDetails");
  }, [radiologyServicesId, dispatch, clinicId, token]);

  const detailOptions = useMemo(() => {
    return radiologyServicesDetails?.map((rs) => {
      const price =
        String(isClient).toLowerCase() === "yes"
          ? rs.client_Price && rs.client_Price !== 0
            ? rs.client_Price
            : rs.pt_price
          : rs.pt_price;

      return {
        value: rs._id,
        label: rs.name,
        type: "radiology",
        price, // IMPORTANT
      };
    });
  }, [radiologyServicesDetails, isClient]);

  const handleSelectedRadiologyPrice = (selectedOptions) => {
    const opts = selectedOptions || [];
    setSelectedRadiologyDetails(opts);

    // Update serviceDetails in parent
    handleChange(
      opts.map((o) => ({
        id: o.value,
        name: o.label,
        price: o.price,
        type: o.type,
      })),
      "serviceDetails"
    );

    // Update total
    const total = opts.reduce((sum, o) => sum + (o.price || 0), 0);
    setTotalAmount(total);
  };

  useEffect(() => {
    if (!selectedRadiologyDetails.length) return;

    const updatedOptions = selectedRadiologyDetails.map((oldOpt) => {
      const fresh = detailOptions.find((o) => o.value === oldOpt.value);
      return {
        ...oldOpt,
        price: fresh?.price ?? 0,
      };
    });

    setSelectedRadiologyDetails(updatedOptions);
    handleSelectedRadiologyPrice(updatedOptions);
  }, [isClient, detailOptions]);


  const newPhysician = physician?.filter((item) =>
    item.specialization.some(
      (spec) => spec.specialization.toLowerCase() === "radiologist"
    )
  );

  return (
    <>
      <div className="col-xl-6">
        <div className="form-group">
          <label className="col-form-label">Radiology Service:</label>
          <Select
            options={radiologyServices?.map((rs) => ({
              value: rs?._id,
              label: rs?.name,
            }))}
            onChange={(selected) => {
              setRadiologyServicesId(selected.value);
              setSelectedRadiologyDetails([]);
              handleChange([], "serviceDetails");
            }}
          />
        </div>
      </div>

      {radiologyServicesId && (
        <div className="col-xl-6">
          <div className="form-group">
            <label className="col-form-label">Radiology Service Details:</label>
            <Select
              isMulti
              options={detailOptions}
              value={selectedRadiologyDetails}
              onChange={handleSelectedRadiologyPrice}
            />
          </div>
        </div>
      )}

      <div className="col-xl-6">
        <div className="form-group">
          <label className="col-form-label">Consulting Physician:</label>
          <Select
            options={newPhysician?.map((phy) => ({
              value: phy?._id,
              label: phy?.userId?.name,
            }))}
            onChange={(e) => handleChange(e, "physician")}
          />
        </div>
      </div>

      <div className="col-xl-6">
        <div className="form-group">
          <label className="col-form-label">Total Amount:</label>
          <input type="number" className="form-control" value={totalAmount} readOnly />
        </div>
      </div>
    </>
  );
};

export default Radiology;
